import { AxiosInstance } from 'axios';
import { FaqReasonsInterface } from 'app/hooks/faq-reasons.types';
import { ButtonInterface } from '@shared/footer/footer';
import { FetchedFieldsData, FormType } from '../../../types/form.types';

interface FormDataInterface {
  fields: FetchedFieldsData;
  knowledgeBaseId: number;
  faqReasonMapping: FaqReasonsInterface;
  makeRecallButton: ButtonInterface;
}

let data: FormDataInterface;

const getFormFieldsService = async (
  client: AxiosInstance,
  formType: FormType
): Promise<FetchedFieldsData> => {
  const response = await client.get(`/${formType}`);
  data = response?.data;
  return response?.data.fields;
};

export const kbId = (): number => data?.knowledgeBaseId;

export const faqQuestionsData = (): FaqReasonsInterface => {
  return data?.faqReasonMapping;
};

export const makeRecallButtonData = (): ButtonInterface => {
  return data?.makeRecallButton;
};

export default getFormFieldsService;
